module.exports = __webpack_public_path__ + "img/green-3-squiggly-solid.17314b6a.svg";